// src/shared/services/onetrust.ts

import { OneTrustGlobals } from '@/features/consent/internal/models/onetrust';

const POLL_MS = 500;
const MAX_ATTEMPTS = 10;

function readOT(): OneTrustGlobals | undefined {
  if (typeof window === 'undefined') return;
  const ot = window.OneTrust;
  return ot && typeof ot === 'object' ? (ot as OneTrustGlobals) : undefined;
}

export async function waitForOT(): Promise<OneTrustGlobals | undefined> {
  if (typeof window === 'undefined') return undefined;
  let attempts = 0;
  const existing = readOT();
  if (existing?.getGeolocationData || existing?.ToggleInfoDisplay) return existing;
  while (attempts < MAX_ATTEMPTS) {
    await new Promise((r) => setTimeout(r, POLL_MS));
    const ot = readOT();
    if (ot?.getGeolocationData || ot?.ToggleInfoDisplay) return ot;
    attempts++;
  }
  return undefined;
}

export async function toggleCookieBanner(): Promise<void> {
  const ot = await waitForOT();
  ot?.ToggleInfoDisplay?.();
}

export function getActiveGroups(): string[] {
  if (typeof window === 'undefined') return [];
  const raw = window.OptanonActiveGroups as string | undefined;
  return raw ? raw.toUpperCase().split(',').filter(Boolean) : [];
}

export function getGeo(): { country?: string; state?: string } {
  return readOT()?.getGeolocationData?.() ?? {};
}
